import { Box, DialogContent, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setProgressBarValue } from "../../redux/actions/commonAction";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 30,
  borderRadius: 16,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 16,
    backgroundColor: theme.palette.success.main,
  },
}));

const ProgressLoader = ({ open }) => {
  const dispatch = useDispatch();
  const { progressBarValue } = useSelector((state) => state.common);

  useEffect(() => {
    const value = progressBarValue >= 99 ? 5 : progressBarValue;
    if (open) {
      const timer = setInterval(() => {
        dispatch(setProgressBarValue(value + 0.5));
      }, 70);
      return () => {
        clearInterval(timer);
      };
    }
    //eslint-disable-next-line
  }, [open, progressBarValue, dispatch]);

  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: "100px" }}>
        <Box display="flex" alignItems="center" flexDirection="column">
          <BorderLinearProgress
            style={{ width: "300px", marginBottom: "12px" }}
            variant="determinate"
            value={progressBarValue}
          />
          <Typography>Processing please wait...</Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProgressLoader;
